// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22l5w","content":"styles_content__18__w","tableWrap":"styles_tableWrap__1Hq9s"};